<template>
  <VPanel class="relative p-6 overflow-hidden">
    <div class="flex justify-between">
      <h1 class="text-lg">مدیریت {{ service ? 'خدمات' : 'محصولات' }}</h1>

      <router-link :to="'/setting/category/' + this.$route.params.type" v-if="user.role.type === 'admin'"
                   class="flex items-center border border-dark-line rounded-lg px-4 py-3 hover:bg-accent">
        <SettingIcon class="ml-2"/>
        مدیریت دسته بندی
      </router-link>
    </div>


    <div class="flex gap-x-16 mt-8 border-b border-dark-line">
      <a
          v-for="category in categories"
          :key="category.id"
          :class="{'text-accent border-b-2 border-accent pb-2' : category.id === activeCategory}"
          href="#"
          @click.prevent="getCategoryProducts(category.id)">
        {{ category.name }}
      </a>
    </div>

    <div class="relative grid grid-cols-3 mt-6 gap-10">
      <a v-if="user.role.type === 'admin'"
          href="#" @click.prevent="modalCreate = true"
          class="flex flex-col justify-center items-center border-2 border-accent border-dashed rounded-xl min-h-[20rem]">
        <PlusIcon/>
        <span class="text-accent">افزودن {{ service ? 'خدمات' : 'محصول' }} جدید</span>
      </a>

      <ProductCard
          v-for="product in products"
          :key="product.id"
          :product="product"
          :categories="categories"
          @edited="productEdited"/>

    </div>

    <VLoadingScreen :show="loading"/>

    <ModalService
        v-if="service"
        :show="modalCreate"
        :categories="categories"
        @click="modalCreate = !modalCreate"
        @created="productCreated"/>

    <ModalProduct
        v-else
        :show="modalCreate"
        :categories="categories"
        @click="modalCreate = !modalCreate"
        @created="productCreated"/>

  </VPanel>
</template>

<script>
import VPanel from "@/components/VPanel";
import ProductCard from "@/components/Setting/ProductCard";
import PlusIcon from "@/components/Icons/PlusIcon";
import SettingIcon from "@/components/Icons/SettingIcon";
import {getCategories, getCategoryProducts} from "@/API/API";
import VLoadingScreen from "@/components/General/VLoadingScreen";
import ModalProduct from "@/components/Modal/ModalProduct";
import ModalService from "@/components/Modal/ModalService";
import {mapState} from "vuex";

export default {
  name: "ProductView",
  components: {ModalService, ModalProduct, VLoadingScreen, SettingIcon, PlusIcon, ProductCard, VPanel},
  data() {
    return {
      categories: [],
      products: [],
      loading: true,
      activeCategory: 0,
      modalCreate: false,
      service: this.$route.params.type === 'service'
    }
  },
  computed: {
    ...mapState(['user'])
  },
  async created() {
    this.categories = (await getCategories(this.$route.params.type)).data
    if (this.categories.length) {
      this.activeCategory = this.categories[0].id
    }

    if (this.service) {
      if (this.activeCategory) {
        this.products = (await getCategoryProducts(this.activeCategory)).data.services
      }
    } else {
      if (this.activeCategory) {
        this.products = (await getCategoryProducts(this.activeCategory)).data.products
      }
    }
    this.loading = false
  },
  methods: {
    async getCategoryProducts(id) {
      this.loading = true
      this.activeCategory = id
      this.products = []

      if (this.service) {
        this.products = (await getCategoryProducts(this.activeCategory)).data.services
      } else {
        this.products = (await getCategoryProducts(this.activeCategory)).data.products
      }
      this.loading = false
    },
    productCreated(product) {
      this.modalCreate = false
      this.getCategoryProducts(product.category_id)
    },
    productEdited(product) {
      this.getCategoryProducts(product.category_id)
    }
  },
  watch: {
    async '$route'() {
      this.activeCategory = 0
      this.products = []
      if (this.$route.params.type) {
        this.service = this.$route.params.type === 'service'
        this.loading = true
        this.categories = (await getCategories(this.$route.params.type)).data
        if (this.categories.length) {
          this.activeCategory = this.categories[0].id
        }
        if (this.service) {
          if (this.activeCategory) {
            this.products = (await getCategoryProducts(this.categories[0].id)).data.services
          }
        } else {
          if (this.activeCategory) {
            this.products = (await getCategoryProducts(this.categories[0].id)).data.products
          }
        }
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>

</style>